module.exports = __webpack_public_path__ + "img/volumes.4bea55fc.png";